import ErrorLogger from "@kaspernj/api-maker/build/error-logger.js"

const railsEnv = digg(window, "RAILS_ENV")

if (railsEnv == "test") {
  class ChunkAwareErrorLogger extends ErrorLogger {
    async loadSourceMapsFromStack(stack) {
      const sources = stack.match(/https?:\/\/[^\s)]+\.js/g) || []
      const unloadedSources = [...new Set(sources)].filter((source) => source.includes("/packs/") && !this.sourceMapsLoader.srcLoaded[source])

      try {
        await Promise.all(unloadedSources.map((source) => {
          const sourceMapUrl = this.sourceMapsLoader.getMapURL({src: source})

          if (!sourceMapUrl) return null

          this.sourceMapsLoader.srcLoaded[source] = true

          return this.sourceMapsLoader.loadSourceMapForSource({originalUrl: source, sourceMapUrl})
        }))
      } catch {
        // Source-map loading is best-effort; a failure must not mask the original error.
      }
    }

    async onError(event) {
      if (event.error?.stack) await this.loadSourceMapsFromStack(event.error.stack)

      return super.onError(event)
    }

    async onUnhandledRejection(event) {
      if (event.reason?.stack) await this.loadSourceMapsFromStack(event.reason.stack)

      return super.onUnhandledRejection(event)
    }
  }

  window.errorLogger = new ChunkAwareErrorLogger()
  window.errorLogger.enable()
}
